import type { HealthServiceSchema } from '@libs/data-access/queries'
import { healthService, requestOptions } from '@libs/data-access/queries'
import { AsyncAutocomplete } from '@libs/ui/ds'
import { Controller } from '@libs/ui/form'
import { forwardRef } from 'react'
import { useFormContext } from 'react-hook-form'

import type { MedecineCodeSelectSourcedProps } from './MedecineCodeSelectSourced.types'

export const MedecineCodeSelectSourced = forwardRef<
  HTMLSelectElement,
  MedecineCodeSelectSourcedProps & {
    healthServiceValue?: HealthServiceSchema
    name: string
  }
>(({ healthServiceValue, name, ...other }, ref) => {
  const {
    control,
    formState: { errors }
  } = useFormContext<{
    [name]: string
  }>()

  const fetchMedecineCodeOptions = async (search: string) => {
    return healthService
      .getFetchHealthServices({
        queryParams: {
          per_page: requestOptions.PAGINATION_DEFAULT_PER_PAGE,
          page: requestOptions.PAGINATION_DEFAULT_PAGE,
          search_name: search
        }
      })
      .then(response => {
        if (!response) {
          return []
        }

        return response.resources.map(item => {
          return {
            label: `${item.code} - ${item.name}`,
            optionLabel: `n° ${item.code}`,
            bottomSection: item.name,
            value: item.id.toString()
          }
        })
      })
  }

  return (
    <Controller.AsyncAutocomplete
      {...other}
      ref={ref}
      className='w-full'
      customTarget={props => (
        <AsyncAutocomplete.Targets.InputLike {...props} label={other.label} />
      )}
      loadOptions={fetchMedecineCodeOptions}
      defaultOptions={
        healthServiceValue
          ? [
              {
                label: `${healthServiceValue.code} - ${healthServiceValue.name}`,
                value: healthServiceValue.id.toString()
              }
            ]
          : true
      }
      control={control}
      name={name}
      dropdownWidth='target'
      errorMessage={errors?.occupational_medicine_code?.message}
    />
  )
})
